export function ComingSoonIcon() {
  return (
    <svg
      width="177"
      height="180"
      fill="none"
      viewBox="0 0 177 180"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>Coming Soon</title>
      <path
        d="M34.8506 18.4932C49.6083 7.50431 67.9033 1.00092 87.7166 1.00092C97.777 1.00092 107.446 2.6778 116.46 5.76629"
        stroke="#043454"
        strokeWidth="1.29189"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeDasharray="8.61 8.61"
      />
      <path
        d="M34.8525 160.716C17.9089 148.1 5.62811 129.571 1.06445 108.185"
        stroke="#043454"
        strokeWidth="1.29189"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeDasharray="8.61 8.61"
      />
      <path
        d="M168.862 53.9684C173.659 64.8728 176.321 76.9279 176.321 89.604C176.321 115.004 165.632 137.908 148.509 154.063"
        stroke="#043454"
        strokeWidth="1.29189"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeDasharray="8.61 8.61"
      />
      <path
        d="M18.5381 89.604C18.5381 51.3975 49.5102 20.4257 87.7167 20.4257C125.923 20.4257 156.896 51.3975 156.896 89.604C156.896 127.81 125.923 158.783 87.7167 158.783C49.5102 158.783 18.5381 127.81 18.5381 89.604Z"
        fill="#C6FED6"
      />
      <path
        d="M90.4236 104H117.448C121.378 104 124.567 107.184 124.567 111.115V150.588C124.567 154.519 121.378 157.703 117.448 157.703H95.7388V163.608H101.902C102.712 163.608 103.365 164.261 103.365 165.07V168.625C103.365 169.43 102.712 170.089 101.902 170.089H95.7388H77.8281H71.6644C70.8549 170.089 70.2015 169.43 70.2015 168.625V165.07C70.2015 164.261 70.8549 163.608 71.6644 163.608H77.8281V157.703H56.1194C52.1842 157.703 49 154.519 49 150.588V111.115C49 107.184 52.1842 104 56.1194 104H82.719H90.4236Z"
        fill="#9397B1"
      />
      <path
        d="M90.4236 104H117.448C121.378 104 124.567 107.184 124.567 111.115V150.588C124.567 154.519 121.378 157.703 117.448 157.703H95.7388V163.608H101.902C102.712 163.608 103.365 164.261 103.365 165.07V168.625C103.365 169.43 102.712 170.089 101.902 170.089H95.7388H77.8281H71.6644C70.8549 170.089 70.2015 169.43 70.2015 168.625V165.07C70.2015 164.261 70.8549 163.608 71.6644 163.608H77.8281V157.703H56.1194C52.1842 157.703 49 154.519 49 150.588V111.115C49 107.184 52.1842 104 56.1194 104H82.719H90.4236Z"
        stroke="#042A89"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M59.833 151.88C57.7903 151.88 56.1343 150.248 56.1343 148.237V113.49C56.1343 111.915 57.4306 110.639 59.0297 110.639H114.54C116.138 110.639 117.433 111.914 117.433 113.488V148.236C117.433 150.248 115.777 151.88 113.734 151.88H59.833Z"
        fill="white"
      />
      <path
        d="M59.833 151.88C57.7903 151.88 56.1343 150.248 56.1343 148.237V113.49C56.1343 111.915 57.4306 110.639 59.0297 110.639H114.54C116.138 110.639 117.433 111.914 117.433 113.488V148.236C117.433 150.248 115.777 151.88 113.734 151.88H59.833Z"
        stroke="#042A89"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M104.511 138.574H69.5103V118.64H104.511V138.574Z"
        fill="#FDDA7C"
      />
      <path
        d="M104.511 138.574H69.5103V118.64H104.511V138.574Z"
        stroke="#042A89"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M81.7949 136.482L82.1718 133.435C82.338 132.09 83.4798 131.081 84.8339 131.081H89.1873C90.5414 131.081 91.6832 132.09 91.8493 133.435L92.2261 136.482"
        fill="white"
      />
      <path
        d="M81.7949 136.482L82.1718 133.435C82.338 132.09 83.4798 131.081 84.8339 131.081H89.1873C90.5414 131.081 91.6832 132.09 91.8493 133.435L92.2261 136.482"
        stroke="#042A89"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M90.3927 125.773C90.3927 127.642 88.8784 129.156 87.0103 129.156C85.1423 129.156 83.6279 127.642 83.6279 125.773C83.6279 123.906 85.1423 122.392 87.0103 122.392C88.8784 122.392 90.3927 123.906 90.3927 125.773Z"
        fill="white"
      />
      <path
        d="M90.3927 125.773C90.3927 127.642 88.8784 129.156 87.0103 129.156C85.1423 129.156 83.6279 127.642 83.6279 125.773C83.6279 123.906 85.1423 122.392 87.0103 122.392C88.8784 122.392 90.3927 123.906 90.3927 125.773Z"
        stroke="#042A89"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M69.0303 144.641H105.59"
        stroke="#042A89"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M76.6942 144.641C76.6942 145.754 75.7919 146.656 74.6789 146.656C73.5659 146.656 72.6636 145.754 72.6636 144.641C72.6636 143.527 73.5659 142.625 74.6789 142.625C75.7919 142.625 76.6942 143.527 76.6942 144.641Z"
        fill="white"
      />
      <path
        d="M76.6942 144.641C76.6942 145.754 75.7919 146.656 74.6789 146.656C73.5659 146.656 72.6636 145.754 72.6636 144.641C72.6636 143.527 73.5659 142.625 74.6789 142.625C75.7919 142.625 76.6942 143.527 76.6942 144.641Z"
        stroke="#042A89"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M99.8652 161.316C99.8652 171.018 107.73 178.884 117.432 178.884C127.135 178.884 135 171.018 135 161.316C135 151.615 127.135 143.749 117.432 143.749C107.73 143.749 99.8652 151.615 99.8652 161.316Z"
        fill="#44ABF4"
      />
      <path
        d="M99.8652 161.316C99.8652 171.018 107.73 178.884 117.432 178.884C127.135 178.884 135 171.018 135 161.316C135 151.615 127.135 143.749 117.432 143.749C107.73 143.749 99.8652 151.615 99.8652 161.316Z"
        stroke="#042A89"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M120.462 152.214C120.462 153.887 119.106 155.243 117.433 155.243C115.76 155.243 114.404 153.887 114.404 152.214C114.404 150.54 115.76 149.186 117.433 149.186C119.106 149.186 120.462 150.54 120.462 152.214Z"
        fill="white"
      />
      <path
        d="M120.462 152.214C120.462 153.887 119.106 155.243 117.433 155.243C115.76 155.243 114.404 153.887 114.404 152.214C114.404 150.54 115.76 149.186 117.433 149.186C119.106 149.186 120.462 150.54 120.462 152.214Z"
        stroke="#042A89"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M119.326 172.192H115.539C115.058 172.192 114.669 171.803 114.669 171.323V159.957C114.669 159.477 115.058 159.088 115.539 159.088H119.326C119.807 159.088 120.196 159.477 120.196 159.957V171.323C120.196 171.803 119.807 172.192 119.326 172.192Z"
        fill="white"
      />
      <path
        d="M119.326 172.192H115.539C115.058 172.192 114.669 171.803 114.669 171.323V159.957C114.669 159.477 115.058 159.088 115.539 159.088H119.326C119.807 159.088 120.196 159.477 120.196 159.957V171.323C120.196 171.803 119.807 172.192 119.326 172.192Z"
        stroke="#042A89"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M46.8005 83.5879H5.16045C2.86268 83.5879 1 81.7252 1 79.4284V38.1609C1 35.8631 2.86268 34.0004 5.16045 34.0004H46.8005C49.0982 34.0004 50.9609 35.8631 50.9609 38.1609V79.4284C50.9609 81.7252 49.0982 83.5879 46.8005 83.5879Z"
        fill="white"
      />
      <path
        d="M46.8005 83.5879H5.16045C2.86268 83.5879 1 81.7252 1 79.4284V38.1609C1 35.8631 2.86268 34.0004 5.16045 34.0004H46.8005C49.0982 34.0004 50.9609 35.8631 50.9609 38.1609V79.4284C50.9609 81.7252 49.0982 83.5879 46.8005 83.5879Z"
        stroke="#042A89"
        strokeWidth="0.7"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M22.1636 56.4121H8.48808C7.79903 56.4121 7.23975 55.8528 7.23975 55.1638V41.4883C7.23975 40.7992 7.79903 40.2409 8.48808 40.2409H22.1636C22.8527 40.2409 23.4119 40.7992 23.4119 41.4883V55.1638C23.4119 55.8528 22.8527 56.4121 22.1636 56.4121Z"
        fill="#FDDA7C"
      />
      <path
        d="M22.1636 56.4121H8.48808C7.79903 56.4121 7.23975 55.8528 7.23975 55.1638V41.4883C7.23975 40.7992 7.79903 40.2409 8.48808 40.2409H22.1636C22.8527 40.2409 23.4119 40.7992 23.4119 41.4883V55.1638C23.4119 55.8528 22.8527 56.4121 22.1636 56.4121Z"
        stroke="#042A89"
        strokeWidth="0.7"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M43.4727 56.4121H29.7972C29.1081 56.4121 28.5488 55.8528 28.5488 55.1638V41.4883C28.5488 40.7992 29.1081 40.2409 29.7972 40.2409H43.4727C44.1618 40.2409 44.7201 40.7992 44.7201 41.4883V55.1638C44.7201 55.8528 44.1618 56.4121 43.4727 56.4121Z"
        fill="#FDDA7C"
      />
      <path
        d="M43.4727 56.4121H29.7972C29.1081 56.4121 28.5488 55.8528 28.5488 55.1638V41.4883C28.5488 40.7992 29.1081 40.2409 29.7972 40.2409H43.4727C44.1618 40.2409 44.7201 40.7992 44.7201 41.4883V55.1638C44.7201 55.8528 44.1618 56.4121 43.4727 56.4121Z"
        stroke="#042A89"
        strokeWidth="0.7"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M22.1636 77.3477H8.48808C7.79903 77.3477 7.23975 76.7884 7.23975 76.0993V62.4238C7.23975 61.7348 7.79903 61.1764 8.48808 61.1764H22.1636C22.8527 61.1764 23.4119 61.7348 23.4119 62.4238V76.0993C23.4119 76.7884 22.8527 77.3477 22.1636 77.3477Z"
        fill="#9397B1"
      />
      <path
        d="M22.1636 77.3477H8.48808C7.79903 77.3477 7.23975 76.7884 7.23975 76.0993V62.4238C7.23975 61.7348 7.79903 61.1764 8.48808 61.1764H22.1636C22.8527 61.1764 23.4119 61.7348 23.4119 62.4238V76.0993C23.4119 76.7884 22.8527 77.3477 22.1636 77.3477Z"
        stroke="#042A89"
        strokeWidth="0.7"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M43.4727 77.3477H29.7972C29.1081 77.3477 28.5488 76.7884 28.5488 76.0993V62.4238C28.5488 61.7348 29.1081 61.1764 29.7972 61.1764H43.4727C44.1618 61.1764 44.7201 61.7348 44.7201 62.4238V76.0993C44.7201 76.7884 44.1618 77.3477 43.4727 77.3477Z"
        fill="#44ABF4"
      />
      <path
        d="M43.4727 77.3477H29.7972C29.1081 77.3477 28.5488 76.7884 28.5488 76.0993V62.4238C28.5488 61.7348 29.1081 61.1764 29.7972 61.1764H43.4727C44.1618 61.1764 44.7201 61.7348 44.7201 62.4238V76.0993C44.7201 76.7884 44.1618 77.3477 43.4727 77.3477Z"
        stroke="#042A89"
        strokeWidth="0.7"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.3647 47.6663L14.0556 51.9023L20.2878 44.7495"
        stroke="#042A89"
        strokeWidth="0.7"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M31.6733 47.6663L35.3642 51.9023L41.5964 44.7495"
        stroke="#042A89"
        strokeWidth="0.7"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M20.1253 68.5388L12.2638 64.0002C11.7073 63.679 11.0117 64.0805 11.0117 64.7229V73.801C11.0117 74.4434 11.7073 74.8449 12.2638 74.5237L20.1253 69.9851C20.6818 69.6639 20.6818 68.8609 20.1253 68.5388Z"
        fill="white"
      />
      <path
        d="M20.1253 68.5388L12.2638 64.0002C11.7073 63.679 11.0117 64.0805 11.0117 64.7229V73.801C11.0117 74.4434 11.7073 74.8449 12.2638 74.5237L20.1253 69.9851C20.6818 69.6639 20.6818 68.8609 20.1253 68.5388Z"
        stroke="#042A89"
        strokeWidth="0.7"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M150.468 56.4209H119.794C118.803 56.4209 118 55.6173 118 54.6268V25.7927C118 24.8022 118.803 23.9986 119.794 23.9986H150.468C151.459 23.9986 152.262 24.8022 152.262 25.7927V54.6268C152.262 55.6173 151.459 56.4209 150.468 56.4209Z"
        fill="white"
      />
      <path
        d="M150.468 56.4209H119.794C118.803 56.4209 118 55.6173 118 54.6268V25.7927C118 24.8022 118.803 23.9986 119.794 23.9986H150.468C151.459 23.9986 152.262 24.8022 152.262 25.7927V54.6268C152.262 55.6173 151.459 56.4209 150.468 56.4209Z"
        stroke="#042A89"
        strokeWidth="0.708877"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M120.89 34.2472C120.935 38.7581 124.517 42.3477 128.99 42.3477C133.464 42.3477 137.091 38.721 137.091 34.2472C137.091 29.7728 133.464 26.1461 128.99 26.1461C124.496 26.2281 120.89 29.7728 120.89 34.2472Z"
        fill="#9397B1"
      />
      <path
        d="M120.89 34.2472C120.935 38.7581 124.517 42.3477 128.99 42.3477C133.464 42.3477 137.091 38.721 137.091 34.2472C137.091 29.7728 133.464 26.1461 128.99 26.1461C124.496 26.2281 120.89 29.7728 120.89 34.2472Z"
        stroke="#042A89"
        strokeWidth="0.708877"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M128.991 26.1461C133.405 26.2082 137.093 29.76 137.093 34.1889C137.093 38.6563 133.458 42.3477 128.991 42.3477C126.805 42.3477 124.737 41.3738 123.268 39.951L129.005 34.1889L128.991 26.1461Z"
        fill="#44ABF4"
      />
      <path
        d="M128.991 26.1461C133.405 26.2082 137.093 29.76 137.093 34.1889C137.093 38.6563 133.458 42.3477 128.991 42.3477C126.805 42.3477 124.737 41.3738 123.268 39.951L129.005 34.1889L128.991 26.1461Z"
        stroke="#042A89"
        strokeWidth="0.708877"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M128.996 34.248L122.903 28.9035L123.002 28.7754C124.476 27.3123 126.091 26.3218 128.727 26.1342L128.991 26.147V33.65L128.996 34.248Z"
        fill="#FDDA7C"
      />
      <path
        d="M128.996 34.248L122.903 28.9035L123.002 28.7754C124.476 27.3123 126.091 26.3218 128.727 26.1342L128.991 26.147V33.65L128.996 34.248Z"
        stroke="#042A89"
        strokeWidth="0.708877"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M140.023 34.248H149.073"
        stroke="#042A89"
        strokeWidth="0.708877"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M140.023 29.748H149.073"
        stroke="#042A89"
        strokeWidth="0.708877"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M140.023 38.748H149.073"
        stroke="#042A89"
        strokeWidth="0.708877"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M122.896 48.9237L135.574 51.1699L145.15 44.4948" fill="white" />
      <path
        d="M122.896 48.9237L135.574 51.1699L145.15 44.4948"
        stroke="#042A89"
        strokeWidth="0.708877"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M124.819 50.1891C125.537 49.1269 125.259 47.6997 124.197 47.0011C123.135 46.3019 121.692 46.5964 120.974 47.658C120.256 48.7197 120.535 50.1475 121.597 50.8461C122.658 51.5453 124.101 51.2508 124.819 50.1891Z"
        fill="#44ABF4"
      />
      <path
        d="M124.819 50.1891C125.537 49.1269 125.259 47.6997 124.197 47.0011C123.135 46.3019 121.692 46.5964 120.974 47.658C120.256 48.7197 120.535 50.1475 121.597 50.8461C122.658 51.5453 124.101 51.2508 124.819 50.1891Z"
        stroke="#042A89"
        strokeWidth="0.708877"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M137.59 52.4909C138.308 51.4286 138.029 50.0014 136.967 49.3028C135.906 48.6036 134.463 48.8982 133.745 49.9598C133.027 51.022 133.305 52.4493 134.367 53.1479C135.429 53.8471 136.872 53.5525 137.59 52.4909Z"
        fill="#44ABF4"
      />
      <path
        d="M137.59 52.4909C138.308 51.4286 138.029 50.0014 136.967 49.3028C135.906 48.6036 134.463 48.8982 133.745 49.9598C133.027 51.022 133.305 52.4493 134.367 53.1479C135.429 53.8471 136.872 53.5525 137.59 52.4909Z"
        stroke="#042A89"
        strokeWidth="0.708877"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M146.998 45.7171C147.716 44.6555 147.437 43.2283 146.376 42.5291C145.314 41.8305 143.871 42.1244 143.153 43.1867C142.435 44.2483 142.714 45.6755 143.775 46.3747C144.837 47.0733 146.28 46.7794 146.998 45.7171Z"
        fill="#44ABF4"
      />
      <path
        d="M146.998 45.7171C147.716 44.6555 147.437 43.2283 146.376 42.5291C145.314 41.8305 143.871 42.1244 143.153 43.1867C142.435 44.2483 142.714 45.6755 143.775 46.3747C144.837 47.0733 146.28 46.7794 146.998 45.7171Z"
        stroke="#042A89"
        strokeWidth="0.708877"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
